import { IconButton } from '@mui/material';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';
import DeleteIcon from '@mui/icons-material/DeleteOutlined';
import EditIcon from '@mui/icons-material/Edit';
import React from 'react';
import { useIntl } from 'react-intl';
import Tooltip from '../../../components/common/kendo/Tooltip';
import { CellCommandConfig } from '../types';
import CellStyles from './CellStyles';

export const CommandCell: React.FunctionComponent<CellCommandConfig> = ({
  dataItem,
  rowType,
  colSpan,
  style,
  className,
  columnIndex,
  disabled,
  add,
  update,
  cancel,
  edit,
  remove,
}) => {
  const classes = CellStyles();
  const intl = useIntl();
  const getTranslatedText = (key: string) => intl.formatMessage({ id: key });
  const inEdit = dataItem.inEdit;
  const isNewItem = dataItem.id === undefined;
  if (rowType === 'groupHeader') {
    return null;
  }
  return inEdit ? (
    <td
      colSpan={colSpan}
      style={style}
      role="gridcell"
      className={className}
      data-grid-col-index={columnIndex}
    >
      <Tooltip
        placement="top"
        data={getTranslatedText('common.add.document.type')}
        childrenElement={
          <span>
            <IconButton
              disableFocusRipple
              disableRipple
              className={classes.iconButton}
              disabled={disabled}
              onClick={() =>
                isNewItem ? add(dataItem) : update(dataItem)
              }
              size="large">
              <AddCircleOutlineIcon
                className={disabled ? '' : classes.ButtonColor}
                fontSize="small"
                color={disabled ? 'disabled' : 'secondary'}
              />
            </IconButton>
          </span>
        }
      />
      <Tooltip
        placement="top"
        data={getTranslatedText('common.discard')}
        childrenElement={
          <span>
            <IconButton
              disableFocusRipple
              disableRipple
              disabled={disabled}
              className={classes.iconButton}
              onClick={() => cancel(dataItem)}
              size="large">
              <CancelOutlinedIcon
                className={disabled ? '' : classes.Cancel}
                fontSize="small"
                color={disabled ? 'disabled' : 'secondary'}
              />
            </IconButton>
          </span>
        }
      />
    </td>
  ) : (
    <td
      colSpan={colSpan}
      style={style}
      role="gridcell"
      className={className}
      data-grid-col-index={columnIndex}
    >
      <Tooltip
        placement="top"
        data={getTranslatedText('common.edit.document.type')}
        childrenElement={
          <span>
            <IconButton
              disableFocusRipple
              disableRipple
              disabled={disabled}
              className={classes.iconButton}
              onClick={() => edit(dataItem)}
              size="large">
              <EditIcon
                className={disabled ? '' : classes.ButtonColor}
                fontSize="small"
                color={disabled ? 'disabled' : 'secondary'}
              />
            </IconButton>
          </span>
        }
      />
      <Tooltip
        placement="top"
        data={getTranslatedText('common.delete.document.type')}
        childrenElement={
          <span>
            <IconButton
              disableFocusRipple
              disableRipple
              disabled={disabled}
              className={classes.iconButton}
              onClick={() => remove(dataItem)}
              size="large">
              <DeleteIcon
                className={disabled ? '' : classes.Remove}
                fontSize="small"
                color={disabled ? 'disabled' : 'secondary'}
              />
            </IconButton>
          </span>
        }
      />
    </td>
  );
};
